import { render, staticRenderFns } from "./choosing-a-pet.vue?vue&type=template&id=9fa9fab6&scoped=true&"
import script from "./choosing-a-pet.vue?vue&type=script&lang=js&"
export * from "./choosing-a-pet.vue?vue&type=script&lang=js&"
import style0 from "./choosing-a-pet.vue?vue&type=style&index=0&id=9fa9fab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa9fab6",
  null
  
)

export default component.exports